<script>
  import { ISSUE_PRIORITY } from '@/_legacy/constants';
  import CloseButton from '@/_legacy/components/Modals/CloseButton.vue';
  import { Icon } from '@/ui/components/icon/Icon';
  import { mapGetters } from 'vuex';
  import { Button as BButton } from '@/ui/components/Button';
  import { du } from '@/ui/i18n/i18n';

  export default {
    name: 'IssueItemModal',
    components: {
      CloseButton,
      Icon,
      BButton,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
      users: {
        type: Object,
        required: false,
        default: null,
      },
    },
    computed: {
      ...mapGetters({
        assigneesStore: 'assignees',
      }),
      assignees() {
        if (this.item.params.assignees.users) {
          const filteredAssignees = this.assigneesStore.filter(a => this.item.params.assignees.users.some(u => u === a.value));

          return filteredAssignees.map(a => a.label).join(', ');
        }

        if (
          !this.item.params.assignees
          || !this.item.params.assignees.users
          || !this.users
        ) {
          return false;
        }

        return this.item.params.assignees.users
          .map(user => this.users[user])
          .join(', ');
      },
      priority() {
        return {
          [ISSUE_PRIORITY.MEDIUM]: {
            text: this.$t('Medium'),
            class: 'badge--yellow',
          },
          [ISSUE_PRIORITY.HIGH]: {
            text: this.$t('High'),
            class: 'badge--red',
          },
        }[this.item.params.priority];
      },
      dueIn() {
        if (!this.item.params.due_in) {
          return this.$t('No due in date provided');
        }

        const lookup = {
          weeks: this.$t('Week(s)'),
          days: this.$t('Days(s)'),
          hours: this.$t('Hours(s)'),
          minutes: this.$t('Min(s)'),
        };
        const dueIn = this.item.params.due_in;

        const result = Object.entries(dueIn)
          .reduce((acc, [label, value]) => {
            if (!label || !value || value <= 0) {
              return acc;
            }

            acc.push(`${value} ${lookup[label]}`);
            return acc;
          }, []);

        return result.join(', ');
      },
    },
    created() {
      //legacy mapping
      this.$du = du;
    },
    methods: {
      modalClosed() {
        this.$emit('close');
      },
    },
  };
</script>

<template>
  <modal @modal-close="modalClosed">
    <div class="modal-wrapper">
      <div class="p-5">
        <div class="flex justify-between mb-4 items-center">
          <heading :level="2">
            {{ $t('common.issue') }}
          </heading>

          <icon
            class="cursor-pointer"
            icon="times"
            size="lg"
            @click.native="modalClosed"
          />
        </div>

        <div class="modal-content modal-content--issue-item">
          <p class="mb-4">
            {{ $t('issues.action-information', { issueTitle: item.params.title }) }}
          </p>

          <div class="item">
            <h4>{{ $t('Title') }}</h4>
            <p class="description">{{ item.params.title }}</p>
          </div>

          <div v-if="item.params.description" class="item">
            <h4>{{ $t('Description') }}</h4>
            <p class="description">{{ item.params.description }}</p>
          </div>

          <div v-if="assignees" class="item">
            <h4>{{ $t('issues.assignees') }}</h4>
            <p class="description">{{ assignees }}</p>
          </div>

          <div class="item">
            <h4>{{ $t('Priority') }}</h4>
            <div class="description">
              <p class="badge " :class="priority.class">
                {{ priority.text }}
              </p>
            </div>
          </div>

          <div v-if="item.executed_at" class="item">
            <h4>{{ $t('Issue was raised at') }}</h4>
            <p class="description">{{ $du(item.executed_at, 'shortDateTime') }}</p>
          </div>
          <div v-else-if="item.params.due_in" class="item">
            <h4>{{ $t('Due after issue has been raised') }}</h4>
            <p class="description">{{ dueIn }}</p>
          </div>
        </div>
      </div>

      <div class="modal-content--issue-item-actions">
        <b-button @click="modalClosed">Close</b-button>
      </div>
    </div>
  </modal>
</template>
